import React, { useState, useEffect } from 'react'
import { Storage, API } from 'aws-amplify'
import { getAuthAccount, listVolunteerCausesByVolunteer, listVolunteerSkillsByVolunteer } from '../../managers/graphql/queries'
import queryString from 'query-string'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Checkbox from '@mui/material/Checkbox'

import ProfileAvatar from '../../components/data-display/ProfileAvatar'

import { useAppSelector, useAppDispatch } from '../../hooks'
import { getVolunteerCausesAndSkills } from '../../managers/redux/slices/authAccount'
import { AuthAccount, StaffProfile, VolunteerSkill, Skill, VolunteerCause, Cause } from '../../API'
import ManageProfile from '../../components/dialogs/account/ManageProfile'

export default function Profile(props: any) {

    const dispatch = useAppDispatch()

    const [showManageProfileDialog, setShowManageProfileDialog] = useState<boolean>(false)

    const authAccount: AuthAccount | null | undefined = useAppSelector(state => state.authAccount.data)
    const selectedStaffProfile: StaffProfile | null = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const volunteerCauses: VolunteerCause[] | null = useAppSelector(state => state.authAccount.causes)
    const volunteerSkills: VolunteerSkill[] | null = useAppSelector(state => state.authAccount.skills)

    const [selectedAuthAccountCauses, setSelectedAuthAccountCauses] = useState<VolunteerCause[] | null>()
    const [selectedAuthAccountSkills, setSelectedAuthAccountSkills] = useState<VolunteerSkill[] | null>()

    const [selectedAuthAccount, setSelectedAuthAccount] = useState<AuthAccount | null>(null)

    useEffect(() => {
        (async () => {
            if (authAccount) {
                const queryParams = queryString.parse(window.location.search)
                if (queryParams.id) {
                    const getAuthAccountResponse: any = await API.graphql({
                        query: getAuthAccount,
                        variables: {
                            id: queryParams.id
                        }
                    })

                    if (getAuthAccountResponse && getAuthAccountResponse.data && getAuthAccountResponse.data.getAuthAccount) {
                        setSelectedAuthAccount(getAuthAccountResponse.data.getAuthAccount)

                        if (getAuthAccountResponse.data.getAuthAccount.volunteerProfileID) {
                            const listVolunteerCausesByVolunteerResponse: any = await API.graphql({
                                query: listVolunteerCausesByVolunteer,
                                variables: {
                                    volunteerProfileID: getAuthAccountResponse.data.getAuthAccount.volunteerProfileID
                                }
                            })

                            const listVolunteerSkillsByVolunteerResponse: any = await API.graphql({
                                query: listVolunteerSkillsByVolunteer,
                                variables: {
                                    volunteerProfileID: getAuthAccountResponse.data.getAuthAccount.volunteerProfileID
                                }
                            })

                            if (listVolunteerCausesByVolunteerResponse.data && listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer && listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer.items && listVolunteerSkillsByVolunteerResponse.data && listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer && listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer.items) {
                                setSelectedAuthAccountCauses(listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer.items)
                                setSelectedAuthAccountSkills(listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer.items)
                            }
                        }
                    }
                } else {
                    setSelectedAuthAccount(authAccount)
                }
            }
        })()
    }, [authAccount])

    useEffect(() => {
        if (authAccount != null && (volunteerCauses == null || volunteerSkills == null)) {
            dispatch(getVolunteerCausesAndSkills())
        }
    }, [volunteerCauses, volunteerSkills, authAccount])

    if (selectedAuthAccount && authAccount && selectedAuthAccount.id == authAccount.id) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 border-bottom">
                        <div className="d-flex flex-row justify-content-between align-items-center my-5">
                            <Typography variant="h3" sx={{ fontFamily: 'Gilroy-Medium' }}>My Profile</Typography>
                            <Button variant="outlined" onClick={() => { setShowManageProfileDialog(true) }}>Edit</Button>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="d-flex flex-row justify-content-start align-items-center my-5">
                            <ProfileAvatar authAccountID={authAccount ? authAccount.id : null} size={100} />
                            <div className="d-flex flex-column justify-content-center align-items-start mx-3">
                                <Typography variant="h3">{authAccount && authAccount.firstName && authAccount.lastName ? `${authAccount.firstName} ${authAccount.lastName}` : 'No name entered'}</Typography>
                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <Typography variant="body1">On Flourish since {authAccount ? `${new Date(authAccount.createdAt).toLocaleDateString()}` : 'NA'}</Typography>
                                    <Chip variant="filled" label={selectedStaffProfile && selectedStaffProfile.role ? selectedStaffProfile.role.toUpperCase() : 'No Role'} className="mx-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 mt-5">
                        <div className="d-flex flex-column justify-content-start align-items-start border rounded p-3 bg-light">
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <Typography variant="h5">Verifications</Typography>
                                <Typography variant="body1">🚧 Coming soon 🚧</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Verified ID</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Background check</Typography>
                            </div>
                        </div>
                        <div className="d-flex flex-column justify-content-start align-items-start border rounded p-3 bg-light my-3">
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Willing to be on call for last-minute or urgent opportunities</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Interested in family-oriented volunteer opportunities</Typography>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 mt-lg-5 container-fluid">
                        <div className="row">
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">First Name</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.firstName ? authAccount.firstName : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Last Name</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.lastName ? authAccount.lastName : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Email</Typography>
                                    <Typography variant="body1">{authAccount ? authAccount.primaryEmail : ''}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Phone</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.phoneNumber ? authAccount.phoneNumber : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Date of Birth</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.dateOfBirth ? authAccount.dateOfBirth : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Gender</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.gender ? authAccount.gender == 'male' ? 'Male' : authAccount.gender == 'female' ? 'Female' : authAccount.gender == 'nonBinary' ? 'Non-binary' : authAccount.gender == 'preferNotToDisclose' ? 'Prefers not to disclose' : authAccount.gender == 'preferToSelfDescribe' ? authAccount.selfDescribedGender ? authAccount.selfDescribedGender : 'Not added' : 'Not added' : 'Not added'}</Typography>
                                </div>
                            </div>
                            {/* <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Address</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.address ? `${authAccount.address.streetAddress} ${authAccount.address.city}, ${authAccount.address.state} ${authAccount.address.zip}` : 'Not added'}</Typography>
                                </div>
                            </div> */}
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Website</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.website ? <a href={authAccount.website.startsWith('https://') ? authAccount.website : `https://${authAccount.website}`} target="_blank">{authAccount.website}</a> : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Work Experience</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.resumeURI ? <a href="#" onClick={async () => {
                                        const uri = await Storage.get(`authAccounts/${authAccount.id}/resume`)
                                        if (uri) {
                                            var a = document.createElement('a');
                                            a.href = uri;
                                            a.setAttribute('target', '_blank');
                                            a.click();
                                        }
                                    }}>Uploaded Resume</a> : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Skills</Typography>
                                    {
                                        volunteerSkills ?
                                            <div className="d-flex flex-row justify-content-end align-items-center flex-wrap">
                                                {
                                                    volunteerSkills.map((volunteerSkill: VolunteerSkill) => {
                                                        return (<Chip variant="outlined" label={volunteerSkill.skill ? volunteerSkill.skill.name : ''} className="m-1" />)
                                                    })
                                                }
                                            </div>
                                            :
                                            <div />
                                    }
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Causes</Typography>
                                    {
                                        volunteerCauses ?
                                            <div className="d-flex flex-row justify-content-end align-items-center flex-wrap">
                                                {
                                                    volunteerCauses.map((volunteerCause: VolunteerCause) => {
                                                        return (<Chip variant="outlined" label={volunteerCause.cause ? volunteerCause.cause.name : ''} className="m-1" />)
                                                    })
                                                }
                                            </div>
                                            :
                                            <div />
                                    }
                                </div>
                            </div>
                            <hr />
                            <div className="col-12 d-flex flex-column justify-content-start align-items-start  my-2">
                                <Typography variant="h5">Bio</Typography>
                                <Typography variant="body1">{authAccount && authAccount.bio ? authAccount.bio : 'Not added'}</Typography>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DIALOGS */}
                <ManageProfile visible={showManageProfileDialog} onClose={() => setShowManageProfileDialog(false)} />
            </div>
        )
    } else if (selectedAuthAccount && authAccount && selectedAuthAccount.id != authAccount.id) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 border-bottom">
                        <div className="d-flex flex-row justify-content-between align-items-center my-5">
                            <Typography variant="h3" sx={{ fontFamily: 'Gilroy-Medium' }}>Profile</Typography>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="d-flex flex-row justify-content-start align-items-center my-5">
                            <ProfileAvatar authAccountID={selectedAuthAccount ? selectedAuthAccount.id : null} size={100} />
                            <div className="d-flex flex-column justify-content-center align-items-start mx-3">
                                <Typography variant="h3">{selectedAuthAccount && selectedAuthAccount.firstName ? `${selectedAuthAccount.firstName} ${selectedAuthAccount.lastName ? selectedAuthAccount.lastName : ''}` : 'No name entered'}</Typography>
                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <Typography variant="body1">On Flourish since {selectedAuthAccount ? `${new Date(selectedAuthAccount.createdAt).toLocaleDateString()}` : 'NA'}</Typography>
                                    <Chip variant="filled" label={selectedStaffProfile && selectedStaffProfile.role ? selectedStaffProfile.role.toUpperCase() : 'No Role'} className="mx-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 mt-5">
                        <div className="d-flex flex-column justify-content-start align-items-start border rounded p-3 bg-light">
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <Typography variant="h5">Verifications</Typography>
                                <Typography variant="body1">🚧 Coming soon 🚧</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Verified ID</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Background check</Typography>
                            </div>
                        </div>
                        <div className="d-flex flex-column justify-content-start align-items-start border rounded p-3 bg-light my-3">
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Willing to be on call for last-minute or urgent opportunities</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center" style={{ filter: 'blur(5px)' }}>
                                <Checkbox disabled />
                                <Typography variant="body1" className="mx-2">Interested in family-oriented volunteer opportunities</Typography>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 mt-lg-5 container-fluid">
                        <div className="row">
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">First Name</Typography>
                                    <Typography variant="body1">{selectedAuthAccount && selectedAuthAccount.firstName ? selectedAuthAccount.firstName : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Last Name</Typography>
                                    <Typography variant="body1">{selectedAuthAccount && selectedAuthAccount.lastName ? selectedAuthAccount.lastName : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Email</Typography>
                                    <Typography variant="body1">{selectedAuthAccount ? selectedAuthAccount.primaryEmail : ''}</Typography>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Phone</Typography>
                                    <Typography variant="body1">{selectedAuthAccount.phoneNumber ? selectedAuthAccount.phoneNumber : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Date of Birth</Typography>
                                    <Typography variant="body1">{selectedAuthAccount.dateOfBirth ? selectedAuthAccount.dateOfBirth : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Gender</Typography>
                                    <Typography variant="body1">{selectedAuthAccount.gender ? selectedAuthAccount.gender : 'Not added'}</Typography>
                                </div>
                            </div>
                            {/* <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Address</Typography>
                                    <Typography variant="body1">{authAccount && authAccount.address ? `${authAccount.address.streetAddress} ${authAccount.address.city}, ${authAccount.address.state} ${authAccount.address.zip}` : 'Not added'}</Typography>
                                </div>
                            </div> */}
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Website</Typography>
                                    <Typography variant="body1">{selectedAuthAccount.website ? <a href={selectedAuthAccount.website.startsWith('https://') ? selectedAuthAccount.website : `https://${selectedAuthAccount.website}`} target="_blank">{selectedAuthAccount.website}</a> : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Work Experience</Typography>
                                    <Typography variant="body1">{selectedAuthAccount.resumeURI ? <a href="#" onClick={async () => {
                                        const uri = await Storage.get(`authAccounts/${selectedAuthAccount.id}/resume`)
                                        if (uri) {
                                            var a = document.createElement('a');
                                            a.href = uri;
                                            a.setAttribute('target', '_blank');
                                            a.click();
                                        }
                                    }}>Uploaded Resume</a> : 'Not added'}</Typography>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Skills</Typography>
                                    {
                                        volunteerSkills ?
                                            <div className="d-flex flex-row justify-content-end align-items-center flex-wrap">
                                                {
                                                    selectedAuthAccountSkills && selectedAuthAccountSkills.map((volunteerSkill: VolunteerSkill) => {
                                                        return (<Chip variant="outlined" label={volunteerSkill.skill ? volunteerSkill.skill.name : ''} className="m-1" />)
                                                    })
                                                }
                                            </div>
                                            :
                                            <div />
                                    }
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex flex-row justify-content-between align-items-center my-2">
                                    <Typography variant="h5">Causes</Typography>
                                    {
                                        volunteerCauses ?
                                            <div className="d-flex flex-row justify-content-end align-items-center flex-wrap">
                                                {
                                                    selectedAuthAccountCauses && selectedAuthAccountCauses.map((volunteerCause: VolunteerCause) => {
                                                        return (<Chip variant="outlined" label={volunteerCause.cause ? volunteerCause.cause.name : ''} className="m-1" />)
                                                    })
                                                }
                                            </div>
                                            :
                                            <div />
                                    }
                                </div>
                            </div>
                            <hr />
                            <div className="col-12 d-flex flex-column justify-content-start align-items-start  my-2">
                                <Typography variant="h5">Bio</Typography>
                                <Typography variant="body1">{selectedAuthAccount.bio ? selectedAuthAccount.bio : 'Not added'}</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="container">
                <div className="row">
                    <Typography variant="h5">Loading profile</Typography>
                </div>
            </div>
        )
    }
}